import React from "react";
import Header from "../components/home/Header";
import OurServices from "../components/OurServices";
import AboutUsHeader from "../components/AboutUsHeader";
import Logos from "../components/Logos";
import Adventures from "../components/Adventures";
import MotionWrapper from "../components/MotionWrapper";
import SpecialServices from "../components/SpecialServices";
import Whatsapp from "../components/Whatsapp";

const Home = () => {
  return (
    <div data-new-gr-c-s-check-loaded="14.1231.0" data-gr-ext-installed>
      <Header />
      <div className="page-wrapper">
              {/* <OurServices /> */}
              <AboutUsHeader />
              <Logos />
              <Adventures />
              {/* <MotionWrapper /> */}
              <SpecialServices />
              <Whatsapp/>
      </div>
    </div>
  );
};

export default Home;
